<form [formGroup]="formGroup">
  <h5>Email delivery settings</h5>
  <span>Allowed from domains (sender email)</span>
  <app-switch-checkbox [disabled]="true" [checked]="hasFromDomainValidation"
    >The initial set of from domains was confirmed by the
    customer</app-switch-checkbox
  >
  <div class="domains" *ngIf="domains.controls.length">
    <div class="domains__item">
      <div class="domains__item__name">Domain name</div>
      <div class="domains__item__toggle" [hidden]="true">DKIM enabled</div>
      <div class="domains__item__action"></div>
    </div>
    <ng-container formArrayName="domains">
      <ng-container *ngFor="let domain of domains.controls; let i = index">
        <div class="domains__item" [formGroup]="domain">
          <div class="domains__item__name">
            <input
              type="text"
              class="form-control"
              placeholder="domain name"
              formControlName="name"
            />
            <div
              class="form-control-feedback text-danger"
              *ngIf="
                domain.get('name').invalid &&
                (domain.get('name').dirty || domain.get('name').touched)
              "
            >
              <span *ngIf="domain.get('name').hasError('required')">
                Domain name is required
              </span>
              <span *ngIf="domain.get('name').hasError('invalidDomainFormat')">
                Fix domain name
              </span>
            </div>
          </div>
          <div class="domains__item__toggle" [hidden]="true">
            <app-switch-checkbox
              [checked]="domain.get('dkimEnabled').value"
              (change)="enableDkimForDomain({ dkimEnabled: $event, idx: i })"
            ></app-switch-checkbox>
          </div>
          <div class="domains__item__action">
            <span
              class="btn btn-danger btn-sm domains__item__action--remove"
              (click)="removeDomain(i)"
              ><i class="fas fa-trash"></i
            ></span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="footer">
    <button class="btn btn-success" (click)="addDomain()">
      <i class="fas fa-plus"></i> Add another
    </button>
    <app-button
      bsClass="primary"
      buttonType="submit"
      [disabled]="formGroup.invalid || disableSave()"
      [labeled]="true"
      (handleClick)="saveChanges()"
      >Save changes</app-button
    >
  </div>
</form>
